import * as yup from 'yup';

import { requiredEmailField } from '@blockpulse3/web-client/forms';

export const schema = yup.object({ email: requiredEmailField }).required();
